<template>
    <div class="InstagramBusinessContentCard w-full max-w-3xs">
        <ContentMedia
            v-bind="{ content }"
            class="bg-center rounded-lg"
            :style="{ paddingTop: height }"
        />

        <div v-if="page">
            <span style="word-wrap: break-word;">{{ mediaUrl }}</span>
        </div>

        <div v-if="(hasLikes || hasStats) && !page" class="p-2">
            <div v-if="hasLikes" class="flex justify-between text-sm">
                <div>
                    <i class="fa fa-heart text-red-500"></i>
                    <span v-text="latestStat.likes"></span>
                </div>
                <div>
                    <i class="fa fa-comment-o text-gray-600"></i>
                    <span v-text="latestStat.comments"></span>
                </div>
            </div>

            <template v-if="hasStats">
                <span
                    v-for="stat of stats"
                    :key="stat.label"
                    class="flex mt-1 text-xs opacity-75 text-left"
                >
                    <span class="flex-1" v-text="stat.label"></span>
                    <span v-text="stat.value"></span>
                </span>
            </template>
        </div>
    </div>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ContentMedia from 'dashboard-js/components/influencers/ContentMedia'

export default {
    components: { ContentMedia },

    props: {
        content: {},
        page: null,
        showStats: {
            default: true,
        },
        height: {
            default: '180%',
        },
    },

    computed: {
        hasLikes() {
            return this.latestStat && this.latestStat.likes !== null
        },

        hasStats() {
            return this.showStats && this.stats.length > 0
        },

        latestStat() {
            return this.$get(this.content, 'latest_stat', {})
        },

        mediaUrl() {
            return this.$get(this.content, 'media_url')
        },

        stats() {
            return [
                {
                    label: 'Visninger',
                    value: this.$get(this.latestStat, 'views_total'),
                },
                {
                    label: 'Unikke visn.',
                    value: this.$get(this.latestStat, 'views_unique'),
                },
            ].filter(stat => stat.value != null)
        },
    },
}
</script>
